export const LocationSortingTypes = {
  By_Distance: 'By Distance',
  By_Distance_And_Timeslots: 'By Distance and Timeslots',
};
